import { render, staticRenderFns } from "./printDeliver.vue?vue&type=template&id=15c8ade4&scoped=true&"
import script from "./printDeliver.vue?vue&type=script&lang=js&"
export * from "./printDeliver.vue?vue&type=script&lang=js&"
import style0 from "./printDeliver.vue?vue&type=style&index=0&id=15c8ade4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c8ade4",
  null
  
)

export default component.exports